import { render, staticRenderFns } from "./TableConfirm.vue?vue&type=template&id=2723537e"
import script from "./TableConfirm.vue?vue&type=script&lang=js"
export * from "./TableConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports